// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".DialogLinkTasksToCourse__Count[data-v-1dec26e2] {\n  margin-bottom: 12px;\n}\n.DialogLinkTasksToCourse__Note[data-v-1dec26e2] {\n  margin-top: 20px;\n  font-size: 13px;\n  color: #6b7b8c;\n}\n", ""]);
// Exports
module.exports = exports;
